export enum AuthEvents {
  LOGIN_REQUESTED = "AUTH_LOGIN_REQUESTED",
  LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS",
  LOGIN_FAILED = "AUTH_LOGIN_FAILED",
  LOGOUT_REQUESTED = "AUTH_LOGOUT_REQUESTED",
  LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS",
  STATE_CHANGED = "AUTH_STATE_CHANGED",
}

export enum GlobalEvents {
  MODULE_REGISTERED = "MODULE_REGISTERED",
  MODULE_UNREGISTERED = "MODULE_UNREGISTERED",
  ERROR_OCCURRED = "ERROR_OCCURRED",
  STATE_CHANGED = "STATE_CHANGED",
  STATE_MACHINE_RESET = "STATE_MACHINE_RESET",
  SERVICE_INITIALIZATION_PROGRESS = "SERVICE_INITIALIZATION_PROGRESS",
}

export enum AdapterEvents {
  STATE_CHANGED = "STATE_CHANGED",
  LOADING_STARTED = "LOADING_STARTED",
  LOADING_FINISHED = "LOADING_FINISHED",
  ERROR_OCCURRED = "ERROR_OCCURRED",
  STATE_RESET = "STATE_RESET",
}

export enum IntegrationEvents {
  MODULE_REGISTERED = "MODULE_REGISTERED",
  MODULE_UNREGISTERED = "MODULE_UNREGISTERED",
  CROSS_MODULE_ERROR = "CROSS_MODULE_ERROR",
  STATE_SYNC_REQUESTED = "STATE_SYNC_REQUESTED",
  STATE_SYNC_RESPONSE = "STATE_SYNC_RESPONSE",
  PERFORMANCE_METRIC = "PERFORMANCE_METRIC",
  HEALTH_CHECK = "HEALTH_CHECK",
}

export enum OrgSessionEvents {
  ORG_SESSION_CHANGED = "ORG_SESSION_CHANGED",
  ORG_SWITCH_FAILED = "ORG_SWITCH_FAILED",
}

export enum ErrorEvents {
  ERROR_OCCURRED = "ERROR_OCCURRED",
  ERROR_NOTIFICATION_SHOW = "ERROR_NOTIFICATION_SHOW",
  ERROR_ANALYTICS_REPORT = "ERROR_ANALYTICS_REPORT",
  ERROR_RETRY_REQUESTED = "ERROR_RETRY_REQUESTED",
  ERROR_DISMISSED = "ERROR_DISMISSED",
}
